import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Footer.module.css";
import FabButton from "../Fab/Fab";

const Footer = () => {
  const location = useLocation();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  return (
    <footer>
      <div className={styles.footerText}>
        Copyright © 2023 Intellect Inc. All Rights Reserved
        <span>
          <a
            href="http://www.intellect.tn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {"     "}www.intellect.tn
          </a>
        </span>
      </div>
      {user && <FabButton />}
    </footer>
  );
};

export default Footer;
